(function() {
  'use strict';

  angular.module('app.forms')
    .directive('fhFormComingSoon', [function() {
      return {
        restrict: "E",
        scope: {},
        bindToController: true,
        controllerAs: 'vm',
        templateUrl: 'forms/fh-form-coming-soon',
        link: function() {},
        controller: [
          'FormService',
          'DeviceService',
          'AnalyticsService',
          '$scope',
          '$timeout',
          function(
            FormService,
            DeviceService,
            AnalyticsService,
            $scope,
            $timeout
          ) {

            var self = this,
              prefillMode = false,
              prefillData = FormService.prefillForm(prefillMode, 'comingSoon');

            self.formData    = prefillData.formData;
            self.formResult  = prefillData.formResult;
            self.formData._source_type = 'comingSoon';

            self.analyticsConfig = {
              googleAnalytics: {
                pageViewUrl: '/ajax-goals/qsu-coming-soon'
              }
            };

            $scope.$on('user-selected-community', function(event, community) {
              self.formData.selected_communities = [community.id];
              self.regionPhone = community.region.sales_phone;
            });

            self.checkFormValidation = function(form) {
              self.triedSubmit = true;

              if (! form.$valid) {
                return;
              }

              processGetInTouchForm();
            };

            function processGetInTouchForm() {
              self.formResult.showForm = false;
              self.formResult.showLoader = true;

              prepareFormData();

              FormService.submit('/forms/quick-signup', self.formData)
                .then(function(result) {
                  self.formResult = result;

                  AnalyticsService.logTrackingClick(self.analyticsConfig);
                });
            }

            function prepareFormData() {

            }

          }]
      };
    }]);
})();